import DeleteIcon from '../../../assets/icons/delete-icon.svg';
import EditIcon from '../../../assets/icons/edit-icon.svg';
import PlusIcon from '../../../assets/icons/plus-grey-icon.svg';
import Checkbox from 'rc-checkbox';
import React from 'react';

export enum ItemType {
  DELETE,
  EDIT,
  ADD,
  TEXT,
  CUSTOM,
  CHECK_BOX,
}

export interface DropDownItem {
  itemType: ItemType;
  onChangeCheckBox?: (isActive: boolean) => void;
  checkboxValue?: boolean;
  itemText?: string;
  itemIcon?: string;
  value?: any;
}

interface DropDownItems {
  items: DropDownItem[];
  onClick: (index: number, type: DropDownItem) => void;
}

const getDropDownItemByType = (item: DropDownItem) => {
  let text = '';
  let icon;

  const getImageIcon = (icon: string | undefined) => (
    <img src={icon} height={15} />
  );

  switch (item.itemType) {
    case ItemType.ADD:
      text = 'הוספה';
      icon = getImageIcon(PlusIcon);
      break;

    case ItemType.DELETE:
      text = 'מחיקה';
      icon = getImageIcon(DeleteIcon);
      break;

    case ItemType.EDIT:
      text = 'עריכה';
      icon = getImageIcon(EditIcon);
      break;

    case ItemType.TEXT:
      text = item.itemText ? item.itemText : '';
      break;

    case ItemType.CUSTOM:
      text = item.itemText ? item.itemText : '';
      icon = getImageIcon(item.itemIcon);
      break;

    case ItemType.CHECK_BOX:
      text = item.itemText ? item.itemText : '';
      icon = (
        <Checkbox
          checked={item.checkboxValue}
          onChange={(e) => {
            item.onChangeCheckBox?.(e.target.checked);
          }}
        />
      );
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      {/*<img src={icon} height={15}/>*/}
      {icon}
      <div style={{ color: '#6A6A6A', marginRight: '10px' }}>{text}</div>
    </div>
  );
};

const DropDownList: React.FC<DropDownItems> = ({ items, onClick }) => {
  return (
    <div
      style={{
        border: '1px solid #E6E6E6',
        backgroundColor: 'white',
        borderRadius: '8px',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingRight: '5px',
        paddingLeft: '5px',
        zIndex: 1000000,
      }}
    >
      <div style={{ color: '#6A6A6A', fontWeight: 'bold' }}>בחר מהרשימה</div>
      <div
        style={{
          height: '1px',
          backgroundColor: 'rgba(106,106,106,0.35)',
          marginTop: '5px',
          marginBottom: '5px',
        }}
      ></div>

      {items.map((item, index) => (
        <div
          onClick={() => {
            onClick(index, item);
          }}
        >
          {index !== 0 && (
            <div
              style={{
                height: '1px',
                backgroundColor: 'rgba(106,106,106,0.15)',
                marginTop: '5px',
                marginBottom: '5px',
              }}
            ></div>
          )}
          {getDropDownItemByType(item)}
        </div>
      ))}
    </div>
  );
};

export default DropDownList;
